export enum SemiConfigProductTypes {
  SANGERCRISPR = 'crispr',
  ORF = 'orf',
  PREDESIGNED_SIRNA = 'sirna',
  PREDESIGNED_SHRNA = 'shrna',
  PREDESIGNED_CRISPR_GRNA = 'crisprgrna',
}

export enum ActiveLinkType {
  ProductSearch = 'productSearch',
  ItemSelection = 'itemSelection',
  Specifications = 'specifications',
  ReviewOrder = 'reviewOrder',
}
